import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Button';

import './style.scss';

export default function TabBar({
  tabs = [],
  activeTabIndex = 0,
  onClick = () => null,
  flexColumn = false,
  render = true,
  className = ''
}) {
  if (!render) {
    return null;
  }

  return (
    <div className={cx('tab-bar', className, { ['tab-bar--column']: flexColumn })}>
      {tabs.map((button, index) => {
        const isButtonString = typeof button === 'string';
        const {
          label = isButtonString ? button : '',
          className,
          onClick: onButtonClick = () => null,
          ...rest
        } = button;

        const props = isButtonString ? null : rest;
        return (
          <Button
            className={cx(className, { active: activeTabIndex === index })}
            key={`tab-button-${index}`}
            label={label}
            onClick={() => {
              isButtonString ? onClick(index) : onButtonClick(index);
            }}
            {...props}
          />
        );
      })}
    </div>
  );
}
TabBar.propTypes = {
  render: PropTypes.bool,
  flexColumn: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
};
